export enum MfeContainer {
  OrderTaking = 'orderTaking',
  Registry = 'registry',
  Cockpit = 'cockpit',
  DocumentHub = 'documentHub'
}

export enum MfeModule {
  MainComponent = 'app',
  Manifest = 'manifest',
}
